import type { NavigationGuardNext } from "vue-router";
import { useUserStore } from "@/stores/user";

export default async function onlySurvey({
  next,
}: {
  next: NavigationGuardNext;
}) {
  const userStore = useUserStore();

  const isSurvey = localStorage.getItem("isSurvey");

  if (isSurvey === "true") {
    return next({
      name: "survey",
    });
  }

  return next();
}
